module.exports = __webpack_public_path__ + "img/NL278.c342131f.png";